export default __webpack_public_path__ + "static/media/lsv.9c8cdeb5.png";